import { ESTIMATOR_STEP_LABELS } from "../constants";

export const formatNumber = (value: number): string =>
  new Intl.NumberFormat("en-CA").format(value);

export const formatPercent = (part: number, whole: number): string =>
  whole > 0 ? `${Math.round((part / whole) * 100)}%` : "—";

/** "2026-09-23" -> "Sep 23". Dates arrive pre-bucketed in UTC from the server. */
export const formatDay = (isoDate: string): string => {
  const [year, month, day] = isoDate.split("-").map(Number);
  if (!year || !month || !day) return isoDate;

  return new Date(Date.UTC(year, month - 1, day)).toLocaleDateString("en-CA", {
    month: "short",
    day: "numeric",
    timeZone: "UTC",
  });
};

export const formatStep = (step: string): string =>
  ESTIMATOR_STEP_LABELS[step] ?? step;
